import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { white, gray, backgroundColor } from 'styles/colors'
import { header1 } from 'styles/texts'
import {
  saveConsultant,
  unsaveConsultant,
  fetchConsultant,
  approveConsultant,
  hideConsultant,
} from 'actions'
import {
  queryStringSelector,
  consultantSelector,
  hasChatSelector,
  chatIdSelector,
  isAdminSelector,
  isConsultantListedSelector,
} from 'selectors'

import Availability from 'components/Availability'
import ProfilePictureComponent from 'components/ProfilePicture'
import Relevance from './Relevance'
import Button from './Button'
import ContactModalButton from 'components/ContactModalButton'
import LogoComponent from 'components/Logo'

const Wrapper = styled.div`
  flex-grow: 1;
  flex-basis: 280px;
  max-width: 335px;
  text-align: center;
  background-color: ${white};
  border-radius: 4px;
  margin: 10px;
  overflow: hidden;
`

const Main = styled(Link)`
  padding: 20px;
  display: block;
  color: initial;
  text-decoration: none;
`

const ProfilePicture = styled(ProfilePictureComponent)`
  margin-top: 10px;
`

const Titles = styled.div`
  margin: 15px 0 11px;
  color: ${gray};
`

const Name = styled.div`
  ${header1};
`

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 30px 0 0;
`

const Buttons = styled.div`
  display: flex;
  border-top: solid 1px ${backgroundColor};
`

const Icon = styled.img`
  margin-right: 3px;
`

const Logo = styled(LogoComponent)`
  text-align: right;
  width: 96px;
  height: 36px;
  object-fit: contain;
`

class Consultant extends React.Component {
  componentDidMount = () => {
    if (!this.props.name) {
      this.props.fetchConsultant(this.props.consultantId)
    }
  }

  render() {
    const {
      consultantId,
      name,
      profilePicture,
      titles,
      employer,
      saveConsultant,
      unsaveConsultant,
      isSaved,
      queryString,
      hasChat,
      chatId,
      isAdmin,
      isListed,
      approveConsultant,
      hideConsultant,
    } = this.props
    return (
      <Wrapper>
        <Main to={`/consultants/${consultantId}${queryString}`}>
          <Relevance consultantId={consultantId} />
          <ProfilePicture src={profilePicture} />
          <Name>{name}</Name>
          <Titles>{titles.join(', ')}</Titles>
          <Bottom>
            <Availability consultantId={consultantId} />
            <Logo name={employer} />
          </Bottom>
        </Main>
        <Buttons>
          {isAdmin && !isListed ? (
            <React.Fragment>
              <ContactModalButton
                consultantId={consultantId}
                renderButton={({ onClick }) => (
                  <Button
                    to={hasChat ? `/chat/${chatId}` : undefined}
                    onClick={hasChat ? undefined : onClick}>
                    <Icon src="/icons/chat.svg" alt="" />
                    <div>Kontakt</div>
                  </Button>
                )}
              />
              <Button onClick={() => approveConsultant(consultantId)}>
                <Icon src="/icons/approve.svg" alt="" />
                <div>Godkjenn</div>
              </Button>
              <Button onClick={() => hideConsultant(consultantId)}>
                <Icon src="/icons/hide.svg" alt="" />
                <div>Skjul</div>
              </Button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ContactModalButton
                consultantId={consultantId}
                renderButton={({ onClick }) => (
                  <Button
                    to={hasChat ? `/chat/${chatId}` : undefined}
                    onClick={hasChat ? undefined : onClick}>
                    <Icon src="/icons/chat.svg" alt="" />
                    <div>Kontakt</div>
                  </Button>
                )}
              />
              <Button
                onClick={() =>
                  isSaved
                    ? unsaveConsultant(consultantId)
                    : saveConsultant(consultantId)
                }
                active={isSaved}>
                <Icon
                  src={isSaved ? '/icons/saved.svg' : '/icons/save.svg'}
                  alt=""
                />
                <div>{isSaved ? 'Lagret' : 'Lagre'}</div>
              </Button>
              <Button to={`/consultants/${consultantId}${queryString}`}>
                <Icon src="/icons/profile.svg" alt="" />
                <div>Se profil</div>
              </Button>
            </React.Fragment>
          )}
        </Buttons>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, { consultantId }) => ({
  name: consultantSelector(state, consultantId).name,
  profilePicture: consultantSelector(state, consultantId).profilePicture,
  titles: consultantSelector(state, consultantId).titles || [],
  employer: consultantSelector(state, consultantId).employer,
  isSaved: consultantSelector(state, consultantId).saved,
  queryString: queryStringSelector(state),
  hasChat: hasChatSelector(state, consultantId),
  chatId: chatIdSelector(state, consultantId),
  isAdmin: isAdminSelector(state),
  isListed: isConsultantListedSelector(state, consultantId),
})

const mapDispatchToProps = {
  saveConsultant,
  unsaveConsultant,
  fetchConsultant,
  approveConsultant,
  hideConsultant,
}

export default connect(mapStateToProps, mapDispatchToProps)(Consultant)



// WEBPACK FOOTER //
// ./src/components/ConsultantList/Consultant/index.js